"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./FloatingCard.styles"));
const FloatingCard = (props) => {
    const { children, title, image, backgroundColor = 'white', textColor = 'black', titleTextColor = 'black', } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, image ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.FloatingCardImage, { backgroundColor: backgroundColor, textColor: textColor },
            typeof image === 'object' ? (react_1.default.createElement(S.LeftSvg, null, image)) : (react_1.default.createElement(S.LeftImage, { source: image, resizeMode: "contain", accessibilityLabel: "Image" })),
            react_1.default.createElement(S.StyledTextContainer, null,
                title && (react_1.default.createElement(S.FloatingCardTitleImage, { backgroundColor: backgroundColor, textColor: titleTextColor }, title)),
                react_1.default.createElement(S.StyledTextImage, { backgroundColor: backgroundColor, textColor: textColor }, children))))) : (react_1.default.createElement(S.FloatingCard, { backgroundColor: backgroundColor, textColor: textColor },
        title && (react_1.default.createElement(S.FloatingCardTitle, { backgroundColor: backgroundColor, textColor: titleTextColor, accessibilityLabel: title }, title)),
        react_1.default.createElement(S.StyledText, { backgroundColor: backgroundColor, textColor: textColor, accessibilityLabel: children }, children)))));
};
exports.default = FloatingCard;
